module.exports = __webpack_public_path__ + "static/media/galeryAbout7.5776f659.jpg";